import { useContext } from "react";

import LabIDContext from '../../store/LabIDContext';
import HeaderClasses from './AppHeader.module.css';

import { NavLink } from "react-router-dom";

const XYZLABS_Header = () => {
	const labid = useContext(LabIDContext);
	const phonestyle = {color: "#ea8b54", fontWeight: "bold", };

    return (
        <div className={HeaderClasses.appHeaderSp}>
			On the road to better health. (customizable)
        </div>
    );
};

export default XYZLABS_Header;